// src/context/AdminContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; 

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    // Only check auth for /admin pages
    if (!location.pathname.startsWith("/admin")) return;

    const token = localStorage.getItem("adminToken");

    if (token) {
      try {
        // Decode token
        const decoded = jwtDecode(token);

        // Store token in admin object for requests
        setAdmin({ id: decoded.id, email: decoded.email, token });
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem("adminToken");
        navigate("/admin/login");
      }
    } else {
      // No token → redirect to login
      navigate("/admin/login");
    }
  }, [location.pathname, navigate]);

  return (
    <AdminContext.Provider value={{ admin, setAdmin }}>
      {children}
    </AdminContext.Provider>
  );
};

// Hook to use admin context
export const useAdmin = () => useContext(AdminContext);